module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form-builder-editor-field', _vm._g({
    attrs: {
      "item": _vm.item,
      "show-hide-in-form": true,
      "show-hide-in-preview": true,
      "show-hide-in-reports": true,
      "show-required": true,
      "show-share-with-participant": true,
      "show-is-shared": true
    }
  }, _vm.$listeners), [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": _vm.item.name + '-label'
    }
  }, [_vm._v("Label")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.label),
      expression: "item.label"
    }],
    staticClass: "form-control",
    attrs: {
      "id": _vm.item.name + '-label',
      "type": "text"
    },
    domProps: {
      "value": (_vm.item.label)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.item, "label", $event.target.value)
      }
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3090fef2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/formbuilder/editors/FormBuilderEditorCheckbox.vue
// module id = 1600
// module chunks = 1